import { useFetchBuildingView } from 'api/assets/buildingViewService';
import { type FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import buildingViewMockData from './mock/buildingViewMock.json';
// import { ChartButton } from '@components/charts/ChartButton';
// import { t } from 'i18next';
// import { ProjectMeasuredVsExpectedChart } from 'pages/Management/ProjectDetailsPage/charts/ProjectMeasuredVsExpectedChart';
// import { ExcessConsumptionCuSUMChart } from 'pages/Changes/ChangeDetailsPage/components/charts/ExcessConsumptionCuSUMChart';
import { useNotFoundPage } from 'hooks/useNotFoundPage';
import BuildingCardAndOverallPerfomance from './components/BuildingCardAndOverallPerfomance';
import TopDetectedChangesTable from './components/TopDetectedChangesTable';
import QuickWinTableSection from './components/QuickWinTableSection';
import ProjectsNeedAttentionSection from './components/ProjectsNeedAttentionSection';
import SankeySection from './components/SankeySection';
import { useFeatureFlag } from 'context/FeatureFlagProvider/FeatureFlagProvider';
import { FEATURE_FLAGS_LIST } from 'lib/featureFlagsList';
import { BackButton } from '@components/backButton';
import useDisclosure from 'hooks/useDisclosure';
import { Button } from 'layout/Button';
import { FileUploadModal } from '@components/fileUpload';
import { NotesModal } from '@components/notes';
import { RiFilePdf2Line, RiFileTextLine } from 'react-icons/ri';

export enum GRADE {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NONE = 'NONE',
}

// const CHART_BUTTON_VALUES = {
//   MEASURED: 'measured',
//   CUSUM: 'cusum',
// };

export interface ActionItem {
  name: string;
  isActionRequired: boolean;
}

const BuildingViewPage: FC = () => {
  const { id } = useParams();
  const { data, isFetching, error, isError } = useFetchBuildingView(id);
  const { validateAndRedirectToNotFound } = useNotFoundPage();
  const [isActionRequired, setIsActionRequired] = useState<ActionItem[]>([]);
  const { hasFeatureFlagPermission } = useFeatureFlag();
  const { isOpen, handleOpen, handleClose } = useDisclosure();
  const {
    isOpen: isNotesOpen,
    handleOpen: handleNotesOpen,
    handleClose: handleNotesClose,
  } = useDisclosure();

  const getSeverityColorByComponentType = (componentType: string): string => {
    const matchingItem = data?.asset.tags.find((item) => {
      return item.type.includes(componentType);
    });
    return matchingItem ? matchingItem.severity_color : 'NEUTRAL';
  };

  useEffect(() => {
    validateAndRedirectToNotFound(isError, error);
  }, [isError, error]);

  return (
    <div className="flex flex-col gap-8">
      {/* DOCUMENTS */}
      {/* TODO: Remove WIP feature  */}
      <div className="flex items-center justify-between">
        <BackButton navigateTo="/app/assets/list#assets" />
        <div className="flex items-center gap-4">
          <Button
            onClick={handleOpen}
            label="Documents"
            variant="tertiary"
            icon={<RiFilePdf2Line size={24} />}
          />
          <Button
            onClick={handleNotesOpen}
            label="Notes"
            variant="tertiary"
            icon={<RiFileTextLine size={24} />}
          />
        </div>

        <FileUploadModal
          isOpen={isOpen}
          handleOpen={handleOpen}
          handleClose={handleClose}
          id={id}
        />
        <NotesModal
          isOpen={isNotesOpen}
          handleClose={handleNotesClose}
          id={id}
        />
      </div>
      {/* HEADER */}
      <BuildingCardAndOverallPerfomance
        asset={data?.asset}
        assetImpact={data?.asset_impact}
        tags={data?.asset.tags}
        renewableEnergy={data?.renewable_energy}
        isFetching={isFetching}
        isActionRequired={isActionRequired}
        setIsActionRequired={setIsActionRequired}
      />
      {/* TABLES */}
      <div className="flex gap-8 items-stretch">
        {/* TOP CHANGES TABLE */}
        <TopDetectedChangesTable
          buildingId={id}
          severity={getSeverityColorByComponentType('OPERATIONS')}
        />

        <QuickWinTableSection buildingId={id} />
      </div>
      {/* NEED ATTENTION PROJECTS TABLE */}
      {hasFeatureFlagPermission(FEATURE_FLAGS_LIST.project.list) && (
        <ProjectsNeedAttentionSection
          buildingId={id}
          severity={getSeverityColorByComponentType('PROJECTS')}
        />
      )}
      {hasFeatureFlagPermission(FEATURE_FLAGS_LIST.buildingView.get_sankey) && (
        <SankeySection
          id={id}
          severity={getSeverityColorByComponentType('CONSUMPTION_DIFFERENCE')}
          onNoteClick={handleNotesOpen}
        />
      )}
    </div>
  );
};
export default BuildingViewPage;
